import React from "react"
import type { PageProps } from "gatsby"
import LinkLayout from "./link-layout"
import RootWrapper from "./root-wrapper"

type PageWrapperProps = {
  children: React.ReactNode
  location: PageProps["location"]
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children, location }) => {
  if (location.pathname.startsWith("/links/")) {
    return <LinkLayout>{children}</LinkLayout>
  }
  return <RootWrapper>{children}</RootWrapper>
}

export default PageWrapper
